import React, { useEffect, useState } from 'react'
import CollapsibleCard from 'Components/collapsibleCard'
import DynamicTable from 'Components/dynamicTable'
import moment from 'moment'
import { toast } from 'react-toastify'
import Proxies from '../../components/proxies'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

let headers = {
  Dealer_ID: 'Dealer ID',
  Dealer_CVR: 'DealerCVR',
  Dealer_KAM_No: 'Dealer Kam No',
  Dealer_Navn: 'Dealer Navn',
  Closed: 'Closed',
  Salesclub: 'Salesclub',
  timeInsert: 'Last Update'
}

const DealersListWithinDates = props => {
  let { startDate, endDate } = props.match.params
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(true)
    Proxies.GET('reports/dealers-list-within-dates', {
      endDate,
      startDate
    })
      .then(responseJSON => {
        if (responseJSON && responseJSON.length && Array.isArray(responseJSON)) {
          setData(
            responseJSON.map(item => {
              item.timeInsert = moment(item.timeInsert).format('DD-MM-YYYY')
              return item
            })
          )
        } else {
          setData([])
        }
      })
      .then(() => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    return <FontAwesomeIcon icon='spinner' spin />
  }
  if (!data.length) {
    toast.error(`No details as on ${endDate}`, {
      autoClose: 5500,
      onClose: () => {
        window.close()
      }
    })
    return <p>No details as on {endDate}</p>
  }
  return (
    <React.Fragment>
      <CollapsibleCard
        header={
          <strong>
            Dealers fra {moment(startDate).format('DD-MM-YYYY')} til {moment(endDate).format('DD-MM-YYYY')}
          </strong>
        }
        startOpen={data.length ? true : false}
      >
        <DynamicTable data={data} headers={headers} />
      </CollapsibleCard>
    </React.Fragment>
  )
}

export default DealersListWithinDates
